import { Directive, ElementRef, inject, input } from '@angular/core';

/**
 * Shows the full text as a native tooltip, but only while the element is
 * cut off by its ellipsis. Checked on hover and focus, so it follows resizes.
 */
@Directive({
  selector: '[appTitleIfTruncated]',
  host: {
    '(mouseenter)': 'update()',
    '(focusin)': 'update()',
  },
})
export class TitleIfTruncatedDirective {
  /** Tooltip text; defaults to the element's own text. */
  readonly appTitleIfTruncated = input<string>('');

  private readonly host = inject<ElementRef<HTMLElement>>(ElementRef);

  update(): void {
    const el = this.host.nativeElement;
    const truncated = el.scrollWidth > el.clientWidth + 1;
    const text = this.appTitleIfTruncated() || el.textContent?.trim() || '';
    if (truncated && text) el.setAttribute('title', text);
    else el.removeAttribute('title');
  }
}
